import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('mn-MN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}
